<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznmezunlar from "@/models/mznmezunlar";
import Banner from "../components/banner";


export default {
  mixins: [apibtoast, apigeneric, mznmezunlar],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner
  },
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {
        Gizlilik: {}
      },
      MznId: this.$route.params.MznId,
      DataUpdate: "",
      ArkadasListesiSorgu:false,
      UserId: null,
      IsUserFirma: false



    };
  },
  methods: {
    Get() {
      this.IsFirma();
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Page: this.Page,
        Filter: "&Id=" + this.MznId
      }).then((res) => {
        this.TableData = res.Data[0];
        this.TableData.Egitimbilgileri = JSON.parse(
          this.TableData.Egitimbilgileri
        );
        this.TableData.Isstajbilgileri = JSON.parse(
          this.TableData.Isstajbilgileri
        );
        this.TableData.Kursbilgileri = JSON.parse(this.TableData.Kursbilgileri);
        this.TableData.Sertifikabilgileri = JSON.parse(
          this.TableData.Sertifikabilgileri
        );
        this.TableData.Sinavbilgisi = JSON.parse(this.TableData.Sinavbilgisi);
        this.TableData.Yabancidilbilgisi = JSON.parse(
          this.TableData.Yabancidilbilgisi
        );
        this.TableData.Bilgisayarbilgisi = JSON.parse(
          this.TableData.Bilgisayarbilgisi
        );
        this.TableData.Yayinbilgilerim = JSON.parse(
          this.TableData.Yayinbilgilerim
        );
        this.TableData.Odulbilgileri = JSON.parse(this.TableData.Odulbilgileri);
        this.TableData.Projebilgileri = JSON.parse(
          this.TableData.Projebilgileri
        );
        this.TableData.Kulturelfaaliyetbilgileri = JSON.parse(
          this.TableData.Kulturelfaaliyetbilgileri
        );
        this.TableData.Dernekuyelikleri = JSON.parse(
          this.TableData.Dernekuyelikleri
        );
        this.TableData.Yetkinlikler = JSON.parse(this.TableData.Yetkinlikler);
        this.TableData.Referanslar = JSON.parse(this.TableData.Referanslar);
        this.TableData.Gizlilik = JSON.parse(this.TableData.Gizlilik);
      });

      this.ArkasSorgu();

    },
    IsFirma(){
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Page: this.Page,
        Filter: "&Userid="+this.TokenUserId,
      }).then((res) => {
        if(res.Data.length > 0){
          this.IsUserFirma = false;
        } else{
          this.IsUserFirma = true;
        }
      });
    },
    ArkasSorgu(){ 

      this.ActionsSingleGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Id: this.MznId, 
      }).then((res) => {  
        this.UserId = res.Data.Userid

      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznarkadaslistesi",
        Page: this.Page,
        Filter: "&Userid="+res.Data.Userid+"&Arkadasuserid="+this.TokenUserId,
      }).then((res) => {
        if(res.Data.length > 0){
          this.ArkadasListesiSorgu = true
        } 
      });
      });
    },
    Yildizla(isimSoyisim) {
      if (!isimSoyisim) return "";
      let isimSoyisimDizisi = isimSoyisim.split(' ');
      let yıldızlıIsimSoyisim = isimSoyisimDizisi.map(function(kelime) {
        if (kelime.length > 1) {
          return kelime[0] + '*'.repeat(kelime.length - 1);
        }
        return kelime;
      });
      return yıldızlıIsimSoyisim.join(' ');
    },
    IsimGoster() {
      if (!this.TableData || !this.TableData.Adisoyadi) return "";

      const gizlilik = this.TableData.Gizlilik || {};
      const kisiselBilgiler = gizlilik.KisiselBilgiler;

      // Kendi profili ise açık göster
      if (this.UserId === this.TokenUserId) {
        return this.TableData.Adisoyadi;
      }

      // Gizlilik Koşulları
      const arkadasMi = this.ArkadasListesiSorgu === true;
      const firmaMi = this.IsUserFirma === true;

      const kosul1 = arkadasMi && (kisiselBilgiler == 1 || kisiselBilgiler == 3) && !firmaMi;
      const kosul2 = kisiselBilgiler == 4;
      const kosul3 = (kisiselBilgiler == 2 || kisiselBilgiler == 3) && firmaMi;

      if (kosul1 || kosul2 || kosul3) {
        return this.TableData.Adisoyadi;
      }

      // Şartlar sağlanmıyorsa yıldızlı göster
      return this.Yildizla(this.TableData.Adisoyadi);
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <Banner />

      <div class="row mb-2">
        <div class="col-sm-12"> 
          <div class="text-sm-end"> 
            <a :href="this.$config.FILES_URL +'web/' +TableData.Cvfile" class="card-link" target="_blank"  v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Ozgecmis == 1 || TableData.Gizlilik.Ozgecmis == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Ozgecmis == 4) || ((TableData.Gizlilik.Ozgecmis == 2 || TableData.Gizlilik.Ozgecmis == 3)  && this.IsUserFirma == true)">
            <button type="button" class="btn btn-warning btn-rounded mb-2 me-2 mt-2" v-if="TableData.Cvfile != null">
              <i class="mdi mdi-file-export-outline mt-5"></i>
              {{ $t("mznmezunlar.Page.ozgecmis") }}
            </button>
            </a>
          </div>
        </div>
      </div>

      <div class="profile-user mt-5">
        <div class="row">
          <div class="col-md-4">
            <div class="profile-header">
              <div class="
                  row
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                ">
                <div class="col-md-6 mb-5">
                  <div class="image-user" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.KisiselBilgiler == 1 || TableData.Gizlilik.KisiselBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.KisiselBilgiler == 4) || ((TableData.Gizlilik.KisiselBilgiler == 2 || TableData.Gizlilik.KisiselBilgiler == 3)  && this.IsUserFirma == true)"
                  >
                    <img v-if="TableData.Fotograf != null" :src="$config.FILES_URL + 'web/' + TableData.Fotograf"
                      alt="" />
                    <img v-if="TableData.Fotograf == null" src="@/assets/images/usericon.png" alt="" />
                  </div>
                </div>

                <div class="col-md-8 mb-5">
                  <div class="name">
                    <p class="title">{{ IsimGoster() }}</p>

                    <p v-if="TableData.Ozetbilgi != null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Ozetbilgi == 1 || TableData.Gizlilik.Ozetbilgi == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Ozetbilgi == 4) || ((TableData.Gizlilik.Ozetbilgi == 2 || TableData.Gizlilik.Ozetbilgi == 3)  && this.IsUserFirma == true))">{{ TableData.Ozetbilgi }}</p>
                  </div>
                </div>

                <div class="col-md-8 mb-5">
                  <div class="contact">
                    <p class="title">İletişim</p>
                    <span v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.İletisimBilgiler == 1 || TableData.Gizlilik.İletisimBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.İletisimBilgiler == 4) || ((TableData.Gizlilik.İletisimBilgiler == 2 || TableData.Gizlilik.İletisimBilgiler == 3)  && this.IsUserFirma == true)">
                    <p>{{ TableData.Eposta }}</p>
                    <p>{{ TableData.Telefon }}</p>
                    <p>{{ TableData.Evadresi }}</p>
                  </span>
                  <span v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.SosyalMedyaBilgileri == 1 || TableData.Gizlilik.SosyalMedyaBilgileri == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.SosyalMedyaBilgileri == 4) || ((TableData.Gizlilik.SosyalMedyaBilgileri == 2 || TableData.Gizlilik.SosyalMedyaBilgileri == 3)  && this.IsUserFirma == true)">
                    
                    <p><span class="bx bxl-linkedin-square"></span><span
                        style="font-weight: bold; color: #8cddff;">LinkedIn: </span>{{ TableData.Linkedin }}</p>
           <!--        <p v-if="TableData.Facebook != null"><span class="bx bxl-facebook-square"></span><span
                        style="font-weight: bold; color: #8cddff;">Facebook: </span>{{ TableData.Facebook }}</p>
                       <p><span style="font-weight: bold; color: #8cddff;">Website: </span>{{ TableData.Website }}</p> --> 
                    <p v-if="TableData.Twitter != null"><span class="bx bxl-twitter"></span><span
                        style="font-weight: bold; color: #8cddff;">Twitter: </span>{{ TableData.Twitter }}</p>
                    <p v-if="TableData.Instagram != null"><span class="bx bxl-instagram"></span><span
                        style="font-weight: bold; color: #8cddff;">Instagram: </span>{{ TableData.Instagram }}</p>
                    </span>
                  </div>
                </div>

                <div class="col-md-8 mb-5">
                  <div class="contact" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.KisiselBilgiler == 1 || TableData.Gizlilik.KisiselBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.KisiselBilgiler == 4) || ((TableData.Gizlilik.KisiselBilgiler == 2 || TableData.Gizlilik.KisiselBilgiler == 3)  && this.IsUserFirma == true)" >
                    <p class="title">Adres</p>
                <!--    <p>{{ TableData.Yasadigiulke }}</p> -->
                    <p>{{ TableData.Yasadigisehirvalue }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-md-8">
            <div class="profile-detail">
              <div class="row d-flex justify-content-center">
                <div class="col-md-6 mb-5">
                  <div class="profile-info">
                    <div class="list-group mb-"> 
                      <p class="title">Hakkımda</p>
                      <p class="text">
                    <!--   <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && TableData.Gizlilik.TCKimlikNo != 0 || ArkadasListesiSorgu==false && TableData.Gizlilik.TCKimlikNo == 2) ">TC. Kimlik No: {{ TableData.Tckimlikno }}</span> -->
                        <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.KisiselBilgiler == 1 || TableData.Gizlilik.KisiselBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.KisiselBilgiler == 4) || ((TableData.Gizlilik.KisiselBilgiler == 2 || TableData.Gizlilik.KisiselBilgiler == 3)  && this.IsUserFirma == true)">Doğum Yeri: {{ TableData.DogumYerivalue }}</span>
                        <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.KisiselBilgiler == 1 || TableData.Gizlilik.KisiselBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.KisiselBilgiler == 4) || ((TableData.Gizlilik.KisiselBilgiler == 2 || TableData.Gizlilik.KisiselBilgiler == 3)  && this.IsUserFirma == true)">Doğum Tarihi: {{ TableData.Dogumtarihi |
                            formatDateTable
                        }}</span>
                  <!--   <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && TableData.Gizlilik.Uyruk != 0 || ArkadasListesiSorgu==false && TableData.Gizlilik.Uyruk == 2) ">Uyruğu: {{ TableData.Uyrukvalue }}</span> -->
                  <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.DurumBilgiler == 1 || TableData.Gizlilik.DurumBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.DurumBilgiler == 4) || ((TableData.Gizlilik.DurumBilgiler == 2 || TableData.Gizlilik.DurumBilgiler == 3)  && this.IsUserFirma == true)">Sağlık Engeli: {{ TableData.Saglikengelivalue }}</span>
                  <!--  <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && TableData.Gizlilik.KisiselBilgiler != 0 || ArkadasListesiSorgu==false && TableData.Gizlilik.KisiselBilgiler == 2) ">Cinsiyeti: {{ TableData.Cinsiyetvalue }}</span> -->
                  <!--      <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && TableData.Gizlilik.KisiselBilgiler != 0 || ArkadasListesiSorgu==false && TableData.Gizlilik.KisiselBilgiler == 2) ">Medeni Hali: {{ TableData.Medenidurumvalue }}</span> 
                        <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && TableData.Gizlilik.DurumBilgiler != 0 || ArkadasListesiSorgu==false && TableData.Gizlilik.DurumBilgiler == 2) ">Ehliyet: {{ TableData.Ehliyetvalue }}</span> -->
                        <span class="list-group-item bold" v-if="(UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.DurumBilgiler == 1 || TableData.Gizlilik.DurumBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.DurumBilgiler == 4) || ((TableData.Gizlilik.DurumBilgiler == 2 || TableData.Gizlilik.DurumBilgiler == 3)  && this.IsUserFirma == true)">İş Arama Durumu: {{ TableData.Isaramadurumuvalue }}</span>
                      </p>
                    </div>
                    <div class=" mb-2" v-if="TableData.Egitimbilgileri !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.EgitimBilgiler == 1 || TableData.Gizlilik.EgitimBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.EgitimBilgiler == 4) || ((TableData.Gizlilik.EgitimBilgiler == 2 || TableData.Gizlilik.EgitimBilgiler == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Eğitim</p>
                      <b-card v-for="Data in TableData.Egitimbilgileri" :key="Data.Id" style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Data.Okul }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Data.Bolum }}-{{ Data.Ogrenimdurumu }}
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;" v-if="Data.DevamEdiyor == 'Evet'">
                          Devam Ediyor
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;" v-else>{{
                            Data.MezuniyetTarihi | formatDateTable
                        }}</b-card-text>
                      </b-card>
                    </div>
                    <div class=" mb-2" v-if="TableData.Isstajbilgileri !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Isstajbilgileri == 1 || TableData.Gizlilik.Isstajbilgileri == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Isstajbilgileri == 4) || ((TableData.Gizlilik.Isstajbilgileri == 2 || TableData.Gizlilik.Isstajbilgileri == 3)  && this.IsUserFirma == true))">
                      <p class="title">İş Deneyimi</p> 
                      <b-card v-for="(Isbilgi, index) in TableData.Isstajbilgileri" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Isbilgi.KurumKurulusAdi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Isbilgi.Pozisyon }} / {{
                            Isbilgi.Departman
                        }}</b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;" v-if="Isbilgi.HalenDevamEdiyor == 'Evet'">{{
                            Isbilgi.BaslangıcYili
                        }} - Devam Ediyor</b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;" v-else>
                        {{ Isbilgi.BaslangıcYili | formatDateTable }}-{{ Isbilgi.AyrılısYili | formatDateTable}}</b-card-text>
                      </b-card>
                    </div>
                    <div class=" mb-2" v-if="TableData.Sinavbilgisi !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Sinavbilgisi == 1 || TableData.Gizlilik.Sinavbilgisi == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Sinavbilgisi == 4) || ((TableData.Gizlilik.Sinavbilgisi == 2 || TableData.Gizlilik.Sinavbilgisi == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Sınav Bilgisi</p>
                      <b-card v-for="(Sinav, index) in TableData.Sinavbilgisi" :key="index" style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Sinav.SinavAdi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Sinav.Not }}
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                            Sinav.Yil
                        }}</b-card-text>
                      </b-card>
                    </div>
                    <div class=" mb-2" v-if="TableData.Odulbilgileri !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Odulbilgileri == 1 || TableData.Gizlilik.Odulbilgileri == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Odulbilgileri == 4) || ((TableData.Gizlilik.Odulbilgileri == 2 || TableData.Gizlilik.Odulbilgileri == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Ödüller</p>
                      <b-card v-for="(Odul, index) in TableData.Odulbilgileri" :key="index" style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Odul.OdulunAdi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Odul.OduluVerenKurum }}
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                            Odul.OdulTarihi
                        }}</b-card-text>
                      </b-card>
                    </div>
                    <div class=" mb-2" v-if="TableData.Dernekuyelikleri !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Dernekuyelikleri == 1 || TableData.Gizlilik.Dernekuyelikleri == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Dernekuyelikleri == 4) || ((TableData.Gizlilik.Dernekuyelikleri == 2 || TableData.Gizlilik.Dernekuyelikleri == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Üye Olunan Topluluk</p>
                      <b-card v-for="(Dernek, index) in TableData.Dernekuyelikleri" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Dernek.Adi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Dernek.Unvan }}
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                            Dernek.Tur
                        }}</b-card-text>
                      </b-card>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="profile-info">
                    <div v-if="TableData.Kariyerhedefi !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Kariyerhedefi == 1 || TableData.Gizlilik.Kariyerhedefi == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Kariyerhedefi == 4) || ((TableData.Gizlilik.Kariyerhedefi == 2 || TableData.Gizlilik.Kariyerhedefi == 3)  && this.IsUserFirma == true)) " class=" mb-5">
                      <p class="title">Kariyer Hedefi</p>
                      <b-card>
                        <b-card-text>{{ TableData.Kariyerhedefi }}</b-card-text>
                      </b-card>
                    </div>
                    <div class=" mb-2" v-if="TableData.Kulturelfaaliyetbilgileri !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Kulturelfaaliyetbilgileri == 1 || TableData.Gizlilik.Kulturelfaaliyetbilgileri == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Kulturelfaaliyetbilgileri == 4) || ((TableData.Gizlilik.Kulturelfaaliyetbilgileri == 2 || TableData.Gizlilik.Kulturelfaaliyetbilgileri == 3)  && this.IsUserFirma == true)) " >
                      <p class="title">İlgi Alanları</p>
                      <b-card v-for="(Faliyet, index) in TableData.Kulturelfaaliyetbilgileri" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Faliyet.Adi }}</b-card-title>
                        
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Faliyet.Duzey }}
                        </b-card-text>
                        <b-card-text style="margin-bottom: -5px;">{{ Faliyet.Tur }}
                        </b-card-text>
                        <b-card-text
                                 v-if="Faliyet.Tur == 'Diğer'"
                                 style="margin-top: -10px; margin-bottom: -5px;">{{ Faliyet.TurAciklama }}
                                </b-card-text>
                      </b-card>
                    </div>

                    <div class=" mb-2" v-if="TableData.Projebilgileri !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Projebilgileri == 1 || TableData.Gizlilik.Projebilgileri == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Projebilgileri == 4) || ((TableData.Gizlilik.Projebilgileri == 2 || TableData.Gizlilik.Projebilgileri == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Projeler</p>
                      <b-card v-for="(Projeler, index) in TableData.Projebilgileri" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -20px">{{ Projeler.Adi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Projeler.Kurum }}
                        </b-card-text>
                        <b-card-text style="margin-bottom: -5px;">{{ Projeler.Ozet }}
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                            Projeler.Yil
                        }}</b-card-text>
                      </b-card>
                    </div>

                    <div class=" mb-2" v-if="TableData.Yabancidilbilgisi !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Yabancidilbilgisi == 1 || TableData.Gizlilik.Yabancidilbilgisi == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Yabancidilbilgisi == 4) || ((TableData.Gizlilik.Yabancidilbilgisi == 2 || TableData.Gizlilik.Yabancidilbilgisi == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Yabancı Diller</p>
                      <b-card v-for="(Dil, index) in TableData.Yabancidilbilgisi" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -5px">{{ Dil.Adi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Dil.Aciklama }}
                        </b-card-text>
                      </b-card>
                    </div>

                    <div class=" mb-2" v-if="TableData.KursBilgiler !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.KursBilgiler == 1 || TableData.Gizlilik.KursBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.KursBilgiler == 4) || ((TableData.Gizlilik.KursBilgiler == 2 || TableData.Gizlilik.KursBilgiler == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Kurs/Eğitim/Seminer/Kongre Bilgileri</p>
                      <b-card v-for="(Kurs, index) in TableData.Kursbilgileri" :key="index" style="margin-top: -10px">
                        <b-card-title style="margin-top: -20px">{{ Kurs.KursAdi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Kurs.Kurum }}
                        </b-card-text>
                        <b-card-text style="margin-top: -5px; margin-bottom: -5px;">{{ Kurs.Aciklama }}
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -10px;">{{
                            Kurs.Sure
                        }}</b-card-text>
                      </b-card>
                    </div>

                    <div class=" mb-2" v-if="TableData.SertifikaBilgiler !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.SertifikaBilgiler == 1 || TableData.Gizlilik.SertifikaBilgiler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.SertifikaBilgiler == 4) || ((TableData.Gizlilik.SertifikaBilgiler == 2 || TableData.Gizlilik.SertifikaBilgiler == 3) && this.IsUserFirma == true))">
                      <p class="title">Sertifika/Belge/Eğitim Bilgileri</p>
                      <b-card v-for="(Sertifika, index) in TableData.Sertifikabilgileri" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Sertifika.SertifikaAdi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Sertifika.Kurum }}
                        </b-card-text>
                        <b-card-text style="margin-top: -5px; margin-bottom: -5px;">{{ Sertifika.Turu }}
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-top: -5px; margin-bottom: -5px;">{{
                            Sertifika.SaglananFaydaGelisim
                        }}</b-card-text>
                        <b-card-text class="small text-muted" style="margin-bottom: -10px;">{{
                            Sertifika.Kategori
                        }}</b-card-text>
                      </b-card>
                    </div>
                    <div class=" mb-2" v-if="TableData.Bilgisayarbilgisi !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Bilgisayarbilgisi == 1 || TableData.Gizlilik.Bilgisayarbilgisi == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Bilgisayarbilgisi == 4) || ((TableData.Gizlilik.Bilgisayarbilgisi == 2 || TableData.Gizlilik.Bilgisayarbilgisi == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Bilgisayar Bilgisi</p>
                      <b-card v-for="(Bilgisayar, index) in TableData.Bilgisayarbilgisi" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Bilgisayar.Adi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Bilgisayar.Kurum }}
                        </b-card-text>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Bilgisayar.Aciklama }}
                        </b-card-text>
                      </b-card>
                    </div>
                    <div class=" mb-2" v-if="TableData.Yetkinlikler !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Yetkinlikler == 1 || TableData.Gizlilik.Yetkinlikler == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Yetkinlikler == 4) || ((TableData.Gizlilik.Yetkinlikler == 2 || TableData.Gizlilik.Yetkinlikler == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Yetkinlikler</p>
                      <b-card v-for="(Yetkinlikler, index) in TableData.Yetkinlikler" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Yetkinlikler.Adi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Yetkinlikler.Aciklama }}
                        </b-card-text>
                      </b-card>
                    </div>
                    <div class="mb-5" v-if="TableData.Yayinbilgilerim !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Yayinbilgilerim == 1 || TableData.Gizlilik.Yayinbilgilerim == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Yayinbilgilerim == 4) || ((TableData.Gizlilik.Yayinbilgilerim == 2 || TableData.Gizlilik.Yayinbilgilerim == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Yayın Bilgilerim</p>
                      <b-card v-for="(Yayın, index) in TableData.Yayinbilgilerim" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Yayın.YayininAdi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{Yayın.Tur}}
                        </b-card-text>
                        <b-card-text style="margin-bottom: -10px;">{{Yayın.YayinlandigiKitapEvi}}/{{ Yayın.YayinlandigiYil }}
                        </b-card-text>
                      </b-card>
                    </div>
                    <div class="mb-5" v-if="TableData.Referanslar !== null && ((UserId ==TokenUserId) || (ArkadasListesiSorgu==true && (TableData.Gizlilik.Referanslar == 1 || TableData.Gizlilik.Referanslar == 3) && this.IsUserFirma == false) || (TableData.Gizlilik.Referanslar == 4) || ((TableData.Gizlilik.Referanslar == 2 || TableData.Gizlilik.Referanslar == 3)  && this.IsUserFirma == true)) ">
                      <p class="title">Referanslar</p>
                      <b-card v-for="(Referanslar, index) in TableData.Referanslar" :key="index"
                        style="margin-top: -10px">
                        <b-card-title style="margin-top: -10px">{{ Referanslar.Adisoyadi }}</b-card-title>
                        <b-card-text style="margin-top: -10px; margin-bottom: -5px;">{{ Referanslar.Unvan }}
                        </b-card-text>
                        <b-card-text style="margin-top: -5px; margin-bottom: -2px;">{{ Referanslar.Eposta }}
                        </b-card-text>
                        <b-card-text class="small text-muted" style="margin-bottom: -10px;">{{
                            Referanslar.CepTelefonu
                        }}</b-card-text>
                      </b-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </Layout>
  </Loader>
</template>
